import React, { useState } from 'react'
import { FaMagnifyingGlass } from 'react-icons/fa6'
import * as styles from './search.module.scss'

const Search = () => {
  const [open, setOpen] = useState(false)
  const [search, setSearch] = useState('')

  return (
    <>
      <button className={`${open ? styles['closeIcon'] : styles['searchIcon']}`} onClick={() => setOpen(!open)}>
        {open ? <>&#10006;</> : <>&#8981;</>}
      </button>
      <form action="/search" method="GET" className={`${styles['searchForm']} ${open && styles['active']}`}>
        <input placeholder="Search" name="q" value={search} onChange={(e) => setSearch(e.target.value)} />
        <button className={styles['submit']} aria-label="Search">
          <FaMagnifyingGlass />
        </button>
      </form>
    </>
  )
}

export default Search
